export interface Checkpoint {
  id: string;
  name: string;
  description: string;
  image: string;
}

export const config = {
  checkpoints: [
    {
      id: 'KJGFLR',
      name: 'Rasti 1',
      description: 'Täällä matot saavat kyytiä, kun pöly lentää ja mattopiiska paukkuu. ',
      image: '/images/checkpoints/checkpoint-01.jpg',
    },
    {
      id: 'QTZBXP',
      name: 'Rasti 2',
      description: 'Alhaalla, missä on viileää ja vähän salaperäistä. Tavarat eivät tänne kuulu, vaikka jotkut niin luulevat.',
      image: '/images/checkpoints/checkpoint-02.jpg',
    },
    {
      id: 'VNYWRQ',
      name: 'Rasti 3',
      description: 'Edestakaisin, ilmaan ja alas – tässä leikki saa kyytiä! Mutta pidä tiukasti kiinni, ettet lennä liikaa.',
      image: '/images/checkpoints/checkpoint-03.jpg',
    },
    {
      id: 'KLMXDJ',
      name: 'Rasti 4',
      description: 'En ole asukki, vaan kylässä vain. Jos tulet autolla, pysy tässä – muuten tulee sanomista.',
      image: '/images/checkpoints/checkpoint-04.jpg',
    },
    {
      id: 'PBVZKE',
      name: 'Rasti 5',
      description: 'Etu ei ole aina ainoa tie – kulje ympäri ja löydät minut. Harvemmin käytetty, mutta yhtä tärkeä.',
      image: '/images/checkpoints/checkpoint-05.jpg',
    },
    {
      id: 'RJQFSC',
      name: 'Rasti 6',
      description: 'Täällä vaatteet tanssivat tuulessa kuin lakanalinnut. Ei sähköä, vaan pelkkää luonnonvoimaa!',
      image: '/images/checkpoints/checkpoint-06.jpg',
    },
    {
      id: 'GHTAWN',
      name: 'Rasti 7',
      description: 'Vaikka näytän makealta, älä pure! Olen tärkeä piilossa maan alla, ja pääni pilkistää kuin karkki nurmikosta.',
      image: '/images/checkpoints/checkpoint-07.jpg',
    },
    {
      id: 'YLUHIX',
      name: 'Rasti 8',
      description: 'Ovet avautuvat ja autot lepäävät. Täällä on hiljaista, mutta joskus koneet heräävät!',
      image: '/images/checkpoints/checkpoint-08.jpg',
    },
    {
      id: 'WFNZOQ',
      name: 'Rasti 9',
      description: 'Talvella pelastan kaatumiselta, vaikka kesällä olen vain hiljaa. Minut avataan vain liukkauden uhatessa.',
      image: '/images/checkpoints/checkpoint-09.jpg',
    },
    {
      id: 'MARTTA',
      name: 'Rasti 10',
      description: 'Soita tai koputa, jos haluat sisään – ehkä siellä odottaa palkinto tai viimeinen yllätys!',
      image: '/images/checkpoints/checkpoint-10.jpg',
    },
  ],
};

export const getCheckpointById = (id?: string): Checkpoint | undefined => {
  return config.checkpoints.find((checkpoint) => checkpoint.id === id);
};
